<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Subsidy</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Subsidy</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Subsidy</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstMealSubsidyType"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedMealSubsidyType"
		dataKey="MealSubsidyTypeID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--MealSubsidyTypeCD-->
				<th>
					<p-columnFilter type="text" field="MealSubsidyTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealSubsidyTypeDesc-->
				<th>
					<p-columnFilter type="text" field="MealSubsidyTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealSubsidyPct-->
				<th>
					<!-- <p-columnFilter type="text" field="MealSubsidyPct" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="MealSubsidyTypeCD">Code<p-sortIcon field="MealSubsidyTypeCD"></p-sortIcon></th>
				<th pSortableColumn="MealSubsidyTypeDesc">Description<p-sortIcon field="MealSubsidyTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="MealSubsidyPct">Subsidy Percent<p-sortIcon field="MealSubsidyPct"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-MealSubsidyType>
			<tr [pSelectableRow]="MealSubsidyType" (dblclick)="onRowDblClick(MealSubsidyType)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ MealSubsidyType[col.field] }}
				</td>

				<td style="font-weight: bold" [style.color]="MealSubsidyType.Active == true ? 'Black' : 'Red'">
					{{ MealSubsidyType["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
